var _title, _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNetworkSettings = function SvgNetworkSettings(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "304px",
    height: "98px",
    viewBox: "0 0 304 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Illustration/set-up/network-settings")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 204,
    height: 98
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration/set-up/network-settings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(18.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.683628, 60.690005) rotate(-5.000000) translate(-100.683628, -60.690005) translate(3.683628, 14.190005)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-13",
    fill: "#E6F4FF",
    points: "4 42 189 42 189.173521 92.0166515 3.98948693 75.8151479"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-7",
    fill: "#82C6FF",
    x: 144,
    y: 61,
    width: 8,
    height: 15,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-6",
    fill: "#FF9265",
    x: 130,
    y: 65,
    width: 8,
    height: 11,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-5",
    fill: "#FFD67C",
    x: 157,
    y: 54,
    width: 8,
    height: 22,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-4",
    fill: "#8ED6C9",
    x: 170,
    y: 48,
    width: 8,
    height: 28,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0131579,0 L159.986842,0 C178.219506,-6.09036631e-15 193,14.9664812 193,33.4285714 L193,42 L4.54747351e-13,42 L4.54747351e-13,33.4285714 C4.5174001e-13,14.9664812 14.7804942,6.09036631e-15 33.0131579,0 Z",
    id: "Rectangle-12",
    fill: "#67B1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1323529,20 L110.867647,20 C112.045313,20 113,20.8954305 113,22 C113,23.1045695 112.045313,24 110.867647,24 L86.1323529,24 C84.9546869,24 84,23.1045695 84,22 C84,20.8954305 84.9546869,20 86.1323529,20 Z",
    id: "Rectangle-11-Copy",
    fill: "#C0E2FF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#67B1F0",
    points: "4.54747351e-13 37 4 37 4.01867232 75.8177013 0.0463542529 75.4701685"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy",
    fill: "#67B1F0",
    points: "189 37 193 37 193.001622 92.351567 189.028031 92.0039228"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNetworkSettings);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";